// extracted by mini-css-extract-plugin
module.exports = {"shareContainer":"ShareArrow_shareContainer__XO0XG","linkButtonWrapper":"ShareArrow_linkButtonWrapper__2dbxW","shareIcon":"ShareArrow_shareIcon__2OKv8"};